import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { Subscription } from 'rxjs';
import { IFieldConfig } from 'src/app/domain/IFieldConfig';
import {
  SystemTypeEnum,
  SystemTypeIdEnum,
} from 'src/app/domain/registration/enums/system-type.enum';
import { TypeCesEnum } from 'src/app/domain/registration/enums/type-ces.enum';
import { DialogConfirmComponent } from 'src/app/shared/components/dialog-confirm/dialog-confirm.component';
import { GlobalUtils } from 'src/app/shared/global-utils';
import { ToastService } from 'src/app/shared/services/toast/toast.service';
import { AuthService } from 'src/app/views/auth/shared/auth.service';
import { PlanService } from '../../plans/crud-service';
import { SystemService } from '../../systems/crud-service';
import { PlanSelectionWizardComponent } from '../../plans/plan-selection-wizard/plan-selection-wizard.component';
import { CustomerPlanItemCancelReasonDialogComponent } from './customer-plan-item-cancel-reason-dialog/customer-plan-item-cancel-reason-dialog.component';
import { CustomerPlanItemEditReasonDialogComponent } from './customer-plan-item-edit-reason-dialog/customer-plan-item-edit-reason-dialog.component';
import {
  CES_CONFIG_FIELDS,
  COLUMNS_TO_SHOW_WEB,
} from './customer-plan-items-config';
import { CustomerPlansSystemModulesComponent } from './customer-plans-system-modules/customer-plans-system-modules.component';
import { SystemModuleSelectComponent } from './system-modules-select/system-module-select.component';

@Component({
  selector: 'app-customer-plan-items',
  templateUrl: './customer-plan-items.component.html',
  styleUrls: ['./customer-plan-items.component.sass'],
})
export class CustomerPlanItemsComponent
  implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild(MatTable) table: MatTable<any>;
  form: FormGroup;
  plans: any[] = [];
  systemSelected: any;
  showAdeshionFee = false;
  showDaysCountQuantity = false;
  dueDateSelected = 0;
  editMode = false;

  indexSelect = -1;
  selectedPlanName: string | null = null;

  @Input()
  typeCes: TypeCesEnum;
  config: IFieldConfig[] = CES_CONFIG_FIELDS;

  @Input()
  itemSelected: { index: number; element: any | undefined };

  @Input()
  partnerSelectedFire: EventEmitter<any>;

  @Input()
  selectedPartnerIds: string[] = [];

  partner: any;

  @Output()
  changeSelected: EventEmitter<any> = new EventEmitter();

  @Input()
  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>([]);

  @Output()
  dataSourceChange: EventEmitter<any> = new EventEmitter();

  @Output()
  hasPendingPlanChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  displayedColumns: String[] = COLUMNS_TO_SHOW_WEB;

  private typeSub: Subscription | undefined;
  private terminalQuantitySub: Subscription | undefined;
  private systemSub: Subscription | undefined;
  private systems: any;

  monthlyValueLoaded = 0;
  rowEdit: any;

  selectedModules: any[] = [];

  // Variações e composições de filiais selecionadas no wizard
  selectedPlanId: string | null = null;
  selectedVariations: any[] = [];
  selectedBranchCompositions: any[] = [];
  selectedMaxBranches: number | null = null;

  /** Seleção pendente do wizard aguardando sistemas carregarem */
  private pendingWizardSelection: any | null = null;

  /** Índice da linha de plano sendo editada via wizard (null = modo novo) */
  private editingPlanItemIndex: number | null = null;

  /** Filiais adicionais repassadas pelo crud-ces para o wizard */
  @Input()
  additionalBranches: any[] = [];

  // Flag para controlar se há plano selecionado mas não aplicado ainda
  hasPendingPlan: boolean = false;

  get typeCesEnum() {
    return TypeCesEnum;
  }

  constructor(
    private fb: FormBuilder,
    private systemService: SystemService,
    private planService: PlanService,
    private cdr: ChangeDetectorRef,
    private toastService: ToastService,
    private dialog: MatDialog,
    private authService: AuthService
  ) { }

  ngOnDestroy(): void {
    this.typeSub?.unsubscribe();
    this.terminalQuantitySub?.unsubscribe();
    this.systemSub?.unsubscribe();
  }

  ngOnInit(): void {
    this.partnerSelectedFire.subscribe((partner: any) => {
      this.partner = partner;

      //   this.getFieldConfig('type')['options'] = Object.values(
      //     SystemTypeEnum
      //   ).filter((value) =>
      //     this.partner?.plans?.some((p: any) => p?.type === SystemTypeIdEnum[value])
      //   );
    });

    this.systemService
      .listAll({ limit: 1000, page: 0 })
      .subscribe((systems: any) => {
        this.systems = systems[0];
        // Se há seleção pendente do wizard aguardando sistemas, aplicar agora
        if (this.pendingWizardSelection) {
          const pending = this.pendingWizardSelection;
          this.pendingWizardSelection = null;
          this.applyWizardSelection(pending);
        }
      });

    this.form = this.createGroup();
    this.form.get('dueDate')?.disable();

    // Verificar plano pendente quando o componente inicializa
    this.updatePendingPlanStatus(!!this.selectedPlanName);

    this.typeSub = this.form.get('type')?.valueChanges.subscribe((value) => {
      this.form.get('system')?.setValue('');

      const typeId = value ? SystemTypeIdEnum[value] : null;
      if (value && typeId) {
        this.getFieldConfig('system')['componentData'] = {
          params: {
            type: typeId,
            partnerId: this.partner?.id
          },
        };
      } else {
        this.getFieldConfig('system')['componentData'] = {
          params: { partnerId: this.partner?.id },
        };
      }

      // Limpa os outros campos
      this.form.get('terminalQuantity')?.setValue('');
      this.form.get('monthlyValue')?.setValue('');
      this.form.get('adhesionFee')?.setValue('');
      this.form.get('dueDate')?.setValue('');
      this.form.get('daysCountQuantity')?.setValue('');
      this.form.get('deploymentValue')?.setValue(0);
      this.form.get('isUnitCommission')?.setValue(false);

      this.showAdeshionFee = false;
      this.showDaysCountQuantity = false;
      this.selectedPlanName = null;
    });

    this.terminalQuantitySub = this.form
      .get('terminalQuantity')
      ?.valueChanges.subscribe((value) => {
        if (!value) return;

        let planSelected = this.plans.find(
          (plan: any) =>
            plan.terminalQuantity === +value &&
            plan.system.id === this.systemSelected?.id
        );

        if (!planSelected) {
          console.warn('Nenhum plano encontrado para os critérios selecionados');
          return;
        }
        this.monthlyValueLoaded = +planSelected?.monthlyValue;
        this.form.get('isUnitCommission')?.setValue(planSelected?.isUnitCommission);
        this.form.get('monthlyValue')?.setValue(planSelected?.monthlyValue);
        this.form.get('adhesionFee')?.setValue(planSelected?.adhesionFee);

        // Calcular dias corridos se necessário
        let dayMonth = new Date().getDate();
        let dueDate = 0;

        // Verificar explicitamente se isDaysCount é true
        if (planSelected?.isDaysCount === true) {
          if (dayMonth > this.systemSelected?.dueDate)
            dueDate = 30 - dayMonth + this.systemSelected?.dueDate;

          if (dayMonth < this.systemSelected?.dueDate)
            dueDate = this.systemSelected?.dueDate - dayMonth;
        }

        this.form.get('daysCountQuantity')?.setValue(dueDate);

        // Definir flags de exibição
        this.showDaysCountQuantity = planSelected?.isDaysCount === true;
        this.showAdeshionFee = planSelected?.adhesionFee > 0;
        this.selectedPlanName = planSelected.system.name;

        // Atualizar status de plano pendente quando terminal quantity muda
        this.updatePendingPlanStatus(true);
      });

    this.systemSub = this.form
      .get('system')
      ?.valueChanges.subscribe((value) => {
        if (!value) return;
        this.form.get('dueDate')?.setValue('');
        this.form.get('terminalQuantity')?.setValue('');
        this.form.get('monthlyValue')?.setValue('');
        this.form.get('adhesionFee')?.setValue('');
        this.form.get('daysCountQuantity')?.setValue('');
        this.form.get('deploymentValue')?.setValue(0);
        this.showAdeshionFee = false;
        this.showDaysCountQuantity = false;

        let system = this.systems.find((s: any) => s.name === value);

        this.dueDateSelected = system.dueDate;
        this.form.get('dueDate')?.setValue(system.dueDate);
        this.systemSelected = system;

        // Emitir evento de plano pendente
        this.updatePendingPlanStatus(true);

        this.getFieldConfig('terminalQuantity').options = this.plans
          .filter(
            (plan: any) =>
              plan?.system?.id === system.id &&
              +SystemTypeIdEnum[this.form.get('type')?.getRawValue()] ===
              plan.type &&
              (plan.partners.length == 0 ||
                plan.partners.some((p: any) => p.id === this.partner?.id))
          )
          .map((plan: any) => {
            return `${plan.terminalQuantity}`;
          });
      });

    this.planService
      .listAll({ limit: 1000, page: 0 })
      .subscribe((plans: any) => {
        this.plans = plans[0];
      });

    // Adicionar verificação de mudanças nos valores críticos do formulário
    this.form.valueChanges.subscribe(() => {
      if (this.selectedPlanName) {
        this.updatePendingPlanStatus(true);
      }
    });
  }

  ngAfterViewInit(): void {
    if (this.authService.isPartner()) {
      this.form.get('adhesionFee')?.disable();
    }

    // Verificar se há plano pendente também após a view ser inicializada
    setTimeout(() => {
      this.updatePendingPlanStatus(this.checkPendingPlan());
    }, 500);
  }

  public getCode(value: any) {
    return `${value}`.padStart(2, '0');
  }

  public saveItem() {
    if (this.authService.isPartner()) {
      let monthlyValueSelected = this.form.get('monthlyValue')?.getRawValue();

      if (this.monthlyValueLoaded > monthlyValueSelected) {
        this.toastService.showWarn(
          'Valor mensal não pode ser menor que o valor mensal do plano selecionado'
        );
        return;
      }
    }

    // Regra de negócio: não permitir dois planos ativos apontando para o mesmo
    // sistema (geraria conflito de acesso).
    if (!this.editMode) {
      const targetSystemId = this.getSystemId(this.systemSelected) ?? this.getSystemId({ system: this.systemSelected });
      if (targetSystemId != null && this.hasActivePlanForSystem(targetSystemId)) {
        this.toastService.showWarn(
          'Já existe um plano ativo para este sistema. Não é permitido dois planos no mesmo sistema (conflito de acesso).'
        );
        return;
      }
    }

    // Se estamos no modo de edição, sempre mostrar o modal de motivo
    if (this.editMode) {
      // Se temos módulos selecionados do PlanSelectionWizard, usá-los
      const modulesToUse = this.selectedModules && this.selectedModules.length > 0 ?
        this.selectedModules : this.dataSource.data[this.rowEdit]?.systemModules || [];
      const variationsToUse = this.selectedVariations && this.selectedVariations.length > 0
        ? this.selectedVariations
        : this.dataSource.data[this.rowEdit]?.variations || [];

      this.updateItem(this.rowEdit, this.itemSelected, (item: any) => {
        let data = this.form.getRawValue();
        data.active = true;
        data.planName = this.selectedPlanName || data.planName || data.name || '';
        data.planId = this.selectedPlanId || this.dataSource.data[this.rowEdit]?.planId || null;

        // Sistema: usa o nome (string) ou o do item para a normalização
        const currentRow = this.dataSource.data[this.rowEdit];
        data.system =
          this.systemSelected?.name ?? this.systemSelected ?? currentRow?.system;
        // Vencimento: respeita o valor sobrescrito no formulário.
        const overriddenDueDate =
          data.dueDate ?? this.dueDateSelected ?? currentRow?.dueDate ?? 0;
        data.dueDate = +overriddenDueDate;

        // Garantir tipo e outros campos
        if (!data.type) {
          const planForSystem = this.plans.find(
            (plan: any) => plan.system?.id === this.systemSelected?.id &&
              plan.terminalQuantity === +data.terminalQuantity
          );

          if (planForSystem) {
            data.type = this.getSystemTypeFromEnum(planForSystem.type);
          } else {
            //Type campo obrigatorio,não pode ir null.
            console.error('Não foi possível determinar o tipo do sistema');
            this.toastService.showError("Tipo de Sistema não definido");
            return
          }
        }

        // Usar os módulos selecionados do wizard ou manter os existentes
        data.systemModules = modulesToUse.map((i: any) => {
          return {
            id: i.id,
            name: i.name,
            adhesionValue: i?.adhesionValue ?? i?.adhesion_value ?? 0,
            accessValue: i?.accessValue ?? i?.access_value ?? 0,
            cost: i?.cost ?? 0
          };
        });
        data.variations = variationsToUse;
        data.branchCompositions = Array.isArray(this.selectedBranchCompositions)
          ? this.selectedBranchCompositions
          : [];

        // Processar dias corridos
        if (!data.daysCountQuantity) {
          data.daysCountQuantity = 0;
          data.daysCountValue = 0;
        } else {
          data.daysCountValue = (+data.monthlyValue / 30) * +data.daysCountQuantity;
        }

        data.id = this.dataSource.data[this.rowEdit].id;
        data.code = this.dataSource.data[this.rowEdit].code;
        data.createdAt = this.dataSource.data[this.rowEdit].createdAt;
        this.dataSource.data[this.rowEdit] = data;
        this.editMode = false;
        let cpa = data.customerPlanAudits ?? [];
        data.isUnitCommission = this.dataSource.data[this.rowEdit]?.isUnitCommission;
        data.customerPlanAudits = [
          ...cpa,
          {
            action: 'U',
            reason: item,
            createdBy: { id: this.authService.getUserId() },
          },
        ];

        this.changeDataSourceChange();
        this.clearForm();
        // Limpar os módulos selecionados após uso
        this.selectedModules = [];
        this.selectedVariations = [];
        // Quando completar a ação, indicar que não há mais plano pendente
        this.updatePendingPlanStatus(false);
      });
      return;
    }

    // Resto do código mantido para adição de novo item
    // Se já temos módulos selecionados do PlanSelectionWizard, podemos usá-los diretamente
    if (this.selectedModules && this.selectedModules.length > 0) {
      this.submitItem(this.selectedModules);
      // Reset após o uso
      this.selectedModules = [];
    }
    // Não abrir diálogo para seleção de módulos, submeter com array vazio
    else {
      this.submitItem([]);
    }
  }

  private submitItem(modules: any, row: any = null) {
    let data = this.form.getRawValue();
    data.active = true;
    data.planName = this.selectedPlanName || data.planName || data.name || '';
    data.planId = this.selectedPlanId || data.planId || null;

    // Verificar se systemSelected existe antes de acessar sua propriedade
    if (this.systemSelected) {
      data.system = this.systemSelected.name;
      data.dueDate = +this.dueDateSelected;
    } else {
      // Caso não esteja definido, use valores padrão ou log
      console.warn('Sistema não está definido corretamente durante submitItem');
      data.system = null;
      data.dueDate = 0;
    }

    // Garantir que o tipo do sistema esteja definido corretamente
    if (!data.type) {
      console.warn('Tipo do sistema não definido no formulário, usando tipo do sistema selecionado');
      console.warn('Quantidade de Terminais pelo form : ', data.terminalQuantity);
      // Tentar obter o tipo a partir do sistema selecionado
      const planForSystem = this.plans.find(
        (plan: any) => plan.system?.id === this.systemSelected?.id &&
          plan.terminalQuantity === +data.terminalQuantity
      );

      if (planForSystem) {
        data.type = this.getSystemTypeFromEnum(planForSystem.type);
      } else {
        console.error('Não foi possível determinar o tipo do sistema');
        this.toastService.showError("Tipo de Sistema não definido");
        return
      }
    }

    // Processar os módulos do sistema
    data.systemModules = modules.map((i: any) => {
      return {
        id: i.id,
        name: i.name,
        adhesionValue: i?.adhesionValue ?? i?.adhesion_value ?? 0,
        accessValue: i?.accessValue ?? i?.access_value ?? 0,
        cost: i?.cost ?? 0
      };
    });
    data.variations = this.selectedVariations && this.selectedVariations.length > 0
      ? this.selectedVariations
      : [];
    data.branchCompositions = Array.isArray(this.selectedBranchCompositions)
      ? this.selectedBranchCompositions
      : [];
    data.maxBranches = this.selectedMaxBranches ?? data.maxBranches ?? null;

    // Processar dias corridos
    if (!data.daysCountQuantity) {
      data.daysCountQuantity = 0;
      data.daysCountValue = 0;
    } else {
      // Calcular o valor dos dias corridos
      data.daysCountValue = (+data.monthlyValue / 30) * +data.daysCountQuantity;
    }

    if (this.editMode) {
      this.updateItem(this.rowEdit, this.itemSelected, (item: any) => {
        data.id = this.dataSource.data[this.rowEdit].id;
        data.code = this.dataSource.data[this.rowEdit].code;
        data.createdAt = this.dataSource.data[this.rowEdit].createdAt;
        this.dataSource.data[this.rowEdit] = data;
        this.editMode = false;
        let cpa = data.customerPlanAudits ?? [];
        data.isUnitCommission = this.dataSource.data[this.rowEdit]?.isUnitCommission;
        data.customerPlanAudits = [
          ...cpa,
          {
            action: 'U',
            reason: item,
            createdBy: { id: this.authService.getUserId() },
          },
        ];

        this.changeDataSourceChange();
        this.clearForm();
        // Quando completar a ação, indicar que não há mais plano pendente
        this.updatePendingPlanStatus(false);
      });
    } else {
      this.dataSource.data.push(data);
      this.changeDataSourceChange();
      this.clearForm();
      // Quando completar a ação, indicar que não há mais plano pendente
      this.updatePendingPlanStatus(false);
    }
  }

  private clearForm() {
    this.form.get('type')?.setValue('');
    this.form.get('system')?.setValue('');
    this.form.get('terminalQuantity')?.setValue('');
    this.form.get('monthlyValue')?.setValue('');
    this.form.get('adhesionFee')?.setValue('');
    this.form.get('dueDate')?.setValue('');
    this.form.get('daysCountQuantity')?.setValue('');
    this.form.get('deploymentValue')?.setValue(0);
    this.form.get('systemModules')?.setValue([]);
    this.form.get('customerPlanAudits')?.setValue([]);
    this.form.get('isUnitCommission')?.setValue(false);
    this.showAdeshionFee = false;
    this.showDaysCountQuantity = false;
    this.selectedPlanName = null;
    this.selectedPlanId = null;
    this.selectedVariations = [];
    // Quando limpar o formulário, indicar que não há mais plano pendente
    this.updatePendingPlanStatus(false);
  }

  get systemTypeEnum() {
    return SystemTypeEnum;
  }

  getDaysCountValueTotal() {
    return this.dataSource.data
      .filter((it) => it.active)
      .reduce((acc: any, value: any) => {
        return acc + +value.daysCountValue;
      }, 0);
  }

  getAdhesionFeeTotal() {
    return this.dataSource.data
      .filter((it) => it.active)
      .reduce((acc: any, value: any) => {
        return acc + +value.adhesionFee;
      }, 0);
  }

  getMonthlyValueTotal() {
    return this.dataSource.data
      .filter((it) => it.active)
      .reduce((acc: any, value: any) => {
        return acc + +value.monthlyValue;
      }, 0);
  }

  getMonthlyValuePartnerTotal() {
    return this.dataSource.data
      .filter((it) => it.active && !it.isUnitCommission)
      .reduce((acc: any, value: any) => {
        return acc + +value.monthlyValue;
      }, 0);
  }

  getMonthlyValueUnitTotal() {
    return this.dataSource.data
      .filter((it) => it.active && it.isUnitCommission)
      .reduce((acc: any, value: any) => {
        return acc + +value.monthlyValue;
      }, 0);
  }

  getDeploymentValueTotal() {
    return this.dataSource.data
      .filter((it) => it.active)
      .reduce((acc: any, value: any) => {
        return acc + +value.deploymentValue;
      }, 0);
  }

  changeDataSourceChange() {
    this.dataSource.data.forEach((item: any) => {
      item.daysCountValue = (+item.monthlyValue / 30) * +item.daysCountQuantity;

      return item;
    });

    // Criar uma cópia profunda dos dados para evitar referências
    let dsData = JSON.parse(JSON.stringify(this.dataSource.data));

    // Processar cada item antes de emitir o dataSource
    dsData = dsData.map((item: any) => {
      // Converter strings para números onde necessário
      item.dueDate = +item.dueDate;
      item.monthlyValue = +item.monthlyValue;
      item.terminalQuantity = +item.terminalQuantity;
      item.adhesionFee = +item.adhesionFee;
      item.daysCountQuantity = +item.daysCountQuantity;
      item.daysCountValue = +item.daysCountValue;
      item.deploymentValue = +item.deploymentValue;

      // Converter nome do sistema para ID
      if (typeof item.system === 'string') {
        item.system = this.getSystemIdByName(item.system);
      }

      // Converter tipo de enum string para número
      if (typeof item.type === 'string' && item.type in SystemTypeIdEnum) {
        item.type = SystemTypeIdEnum[item.type];
      }

      // Garantir que isUnitCommission seja booleano
      item.isUnitCommission = !!item.isUnitCommission;

      return item;
    });

    this.dataSourceChange.emit(new MatTableDataSource<any>(dsData));

    this.dataSource._updateChangeSubscription();
    this.table.renderRows();
    this.cdr.detectChanges();
  }

  public select(selected: any) {
    this.changeSelected.emit(selected);
    this.indexSelect = selected;
    this.itemSelected = selected;
  }

  public getFieldConfig(name: string): any {
    return this.config.find((c) => c.name === name);
  }

  public get controls() {
    return this.config
      .filter(({ type }) => type !== 'button')
      .map((control) => {
        if (this.typeCes === TypeCesEnum.SHOW) {
          control.disabled = true;
        } else {
          control.disabled = false;
        }

        return control;
      });
  }

  public createGroup() {
    const group = this.fb.group({});
    this.controls.forEach((control) =>
      group.addControl(control.name, this.createControl(control))
    );

    return group;
  }

  public createControl(config: IFieldConfig) {
    const { disabled, validation, value } = config;
    return this.fb.control({ disabled, value }, validation);
  }

  private getSystemIdByName(system: any): number | null {
    if (!system) {
      console.warn('Nome do sistema não fornecido para conversão para ID');
      return null;
    }

    if (typeof system !== 'string') {
      console.warn('Sistema já é um objeto ou ID, não é necessário converter:', system);
      return system;
    }

    const systemObj = this.systems.find((s: any) => s.name === system);
    if (!systemObj) {
      console.error('Sistema não encontrado:', system);
      return null;
    }

    return systemObj.id;
  }

  public editItem(row: number, element: any) {
    const terminalQty = element.terminalQuantity;
    this.form.get('type')?.setValue(element.type);
    this.form.get('system')?.setValue(element.system);

    // Buscar o sistema na lista de sistemas
    this.systemSelected = this.systems?.find((s: any) => s.name === element.system) || null;

    // Se encontramos o sistema, definir o dueDate
    if (this.systemSelected) {
      this.dueDateSelected = this.systemSelected.dueDate;
    } else {
      // Se não encontramos, use o valor do elemento
      this.dueDateSelected = element.dueDate || 0;
      console.warn('Sistema não encontrado na lista de sistemas durante edição:', element.system);
    }

    setTimeout(() => {
      const termOptions = this.getFieldConfig('terminalQuantity').options || [];
      const terminalQtyStr = `${terminalQty}`;

      if (!termOptions.includes(terminalQtyStr)) {
        this.getFieldConfig('terminalQuantity').options = [...termOptions, terminalQtyStr];
      }
      this.form.get('terminalQuantity')?.setValue(terminalQtyStr);
      this.form.get('monthlyValue')?.setValue(element.monthlyValue);
      this.form.get('adhesionFee')?.setValue(element.adhesionFee);
      this.form.get('dueDate')?.setValue(element.dueDate);
      this.form.get('daysCountQuantity')?.setValue(element.daysCountQuantity);
      this.form.get('deploymentValue')?.setValue(element.deploymentValue);
      this.form.get('systemModules')?.setValue(element.systemModules);
      this.form.get('customerPlanAudits')?.setValue(element.customerPlanAudits);
      this.form.get('isUnitCommission')?.setValue(element.isUnitCommission);

      // Definir os flags de exibição
      this.showAdeshionFee = element.adhesionFee > 0;
      this.showDaysCountQuantity = element.daysCountQuantity > 0;

      // Garantir que selectedPlanName seja seguramente definido
      this.selectedPlanName = element.system || '';

      // Marcar como plano pendente quando entrar no modo de edição
      this.updatePendingPlanStatus(true);
    }, 300);

    this.editMode = true;
    this.rowEdit = row;
  }

  public removeItem(row: number, element: any) {
    GlobalUtils.openDialog({
      dialog: this.dialog,
      data: { title: `Remover item` },
      component: DialogConfirmComponent,
      callBack: (data: any) => {
        if (data?.result) {
          this.dataSource.data = this.dataSource.data.filter(
            (item: any) => item !== element
          );

          this.changeDataSourceChange();
        }
      },
    });
  }

  public showInfo(row: number, element: any) {
    const formattedElement = {
      ...element,
      systemModules: Array.isArray(element.systemModules) ? element.systemModules : [],
      customerPlanAudits: Array.isArray(element.customerPlanAudits) ? element.customerPlanAudits : []
    };

    if (formattedElement.systemModules.length === 0) {
      console.warn('Nenhum módulo encontrado para exibição. Verificando dados:', element);
    }

    GlobalUtils.openDialog({
      dialog: this.dialog,
      data: {
        title: `Detalhe do item`,
        element: formattedElement,
        type: this.typeCes
      },
      component: CustomerPlansSystemModulesComponent,
      dialogConfig: {
        width: '700px',
        maxWidth: '90vw',
        maxHeight: '90vh',
        panelClass: 'module-info-dialog'
      },
      callBack: (data: any) => {
      },
    });
  }

  public updateItem(row: any, element: any, callback: Function) {
    GlobalUtils.openDialog({
      dialog: this.dialog,
      data: {
        typeCes: TypeCesEnum.EDIT,
        title: 'EDITAR',
        element,
      },
      component: CustomerPlanItemEditReasonDialogComponent,
      callBack: (data: any) => {
        if (data?.result) callback(data.updateReason);
      },
    });
  }

  public cancelItem(row: any, element: any) {
    GlobalUtils.openDialog({
      dialog: this.dialog,
      data: {
        typeCes: TypeCesEnum.EDIT,
        title: 'CANCELAMENTO',
        element,
      },
      component: CustomerPlanItemCancelReasonDialogComponent,
      callBack: (data: any) => {
        if (data?.result) {
          this.dataSource.data = this.dataSource.data.map((item: any) => {
            if (item === element) {
              item.active = false;
              item.canceledAt = new Date();
              item.cancellationReason = data.cancellationReason;
            }

            return item;
          });

          this.changeDataSourceChange();
        }
      },
    });
  }

  public getNgClass(element: any, index: number) {
    if (index === this.indexSelect) return 'selected';

    let type =
      element.type === this.systemTypeEnum.SYSTEM ? 'system' : 'application';
    let disabled = element.active ? '' : 'disabled';

    return `${type} ${disabled}`;
  }

  public isEditable(i: any, element: any): any {
    return (
      !this.authService.isPartner() && this.typeCes !== this.typeCesEnum.SHOW
    );
  }

  public isRemovable(i: any, element: any): any {
    if (!this.authService.isPartner()) {
      return true;
    }

    return this.typeCes == TypeCesEnum.EDIT && !element.id;
  }

  public cancelEdit() {
    this.editMode = false;
    this.rowEdit = null;
    this.clearForm();
    this.updatePendingPlanStatus(false);
  }

  private getSystemTypeFromEnum(value: number): string {
    const match = Object.entries(SystemTypeIdEnum).find(([key, val]) => val === value);
    const result = match ? match[0] : '';

    return result;
  }

  public onSystemSelect(event: any, preSelection?: {
    preSelectedPlan?: any;
    preSelectedSystem?: any;
    preSelectedModules?: any[];
    preSelectedBranchCompositions?: any[];
    preSelectedVariationValues?: any[];
    preSelectedMaxBranches?: number | null;
  }): void {
    const selectedPartnerIds = this.selectedPartnerIds;

    const dialogData: any = {
      width: '80%',
      height: '85%',
      disableClose: false,
      data: {
        selectedPartnerIds,
        additionalBranches: Array.isArray(this.additionalBranches) ? this.additionalBranches : [],
        ...(preSelection?.preSelectedPlan ? { preSelectedPlan: preSelection.preSelectedPlan } : {}),
        ...(preSelection?.preSelectedSystem ? { preSelectedSystem: preSelection.preSelectedSystem } : {}),
        ...(preSelection?.preSelectedModules?.length ? { preSelectedModules: preSelection.preSelectedModules } : {}),
        ...(preSelection?.preSelectedBranchCompositions?.length ? { preSelectedBranchCompositions: preSelection.preSelectedBranchCompositions } : {}),
        ...(preSelection?.preSelectedVariationValues?.length ? { preSelectedVariationValues: preSelection.preSelectedVariationValues } : {}),
        ...(preSelection?.preSelectedMaxBranches != null ? { preSelectedMaxBranches: preSelection.preSelectedMaxBranches } : {})
      }
    };

    const dialogRef = this.dialog.open(PlanSelectionWizardComponent, dialogData);

    dialogRef.afterClosed().subscribe((data: any) => {
      if (data?.system && data?.plan) {
        if (!this.systems?.length) {
          this.pendingWizardSelection = data;
          return;
        }
        this.applyWizardSelection(data);
        return;
      }

      this.clearEditingPlanItemContext();
    });
  }

  private applyWizardSelection(data: any): void {
    const selectedPlan = data.plan;
    const selectedSystem = data.system;

    if (this.editingPlanItemIndex !== null) {
      const rowIndex = this.editingPlanItemIndex;
      this.clearEditingPlanItemContext();
      this.applyWizardSelectionToEditingRow(data, rowIndex);
      this.clearForm();
      this.updatePendingPlanStatus(false);
      this.selectedPlanName = null;
      return;
    }

    this.selectedPlanName = selectedPlan?.name || selectedSystem.name;
    this.selectedPlanId = selectedPlan?.id || null;
    const systemType = this.getSystemTypeFromEnum(selectedPlan.type);

    this.form.get('type')?.setValue(systemType);
    this.systemSelected = this.systems.find(
      (s: any) => s.id === selectedSystem.id || s.name === selectedSystem.name
    ) || selectedSystem;
    this.form.get('system')?.setValue(this.systemSelected?.name || selectedSystem.name);

    const fallbackDueDate = this.systemSelected?.dueDate ?? selectedPlan?.dueDate ?? 0;
    this.dueDateSelected = fallbackDueDate;
    this.form.get('dueDate')?.setValue(fallbackDueDate);

    this.getFieldConfig('terminalQuantity').options = this.plans
      .filter((plan: any) =>
        plan?.system?.id === this.systemSelected?.id &&
        plan.type === selectedPlan.type &&
        (plan.partners.length === 0 ||
          plan.partners.some((p: any) => p.id === this.partner?.id)))
      .map((plan: any) => `${plan.terminalQuantity}`);

    const terminalQuantity = `${selectedPlan.terminalQuantity ?? ''}`;
    this.form.get('terminalQuantity')?.setValue(terminalQuantity);

    const summary = data.summary || {};
    const monthlyValue = summary.monthlyValue ?? selectedPlan.monthlyValue;
    const adhesionFee = summary.adhesionFee ?? selectedPlan.adhesionFee;
    const dueDate = summary.dueDate ?? fallbackDueDate;

    this.form.get('monthlyValue')?.setValue(monthlyValue);
    this.form.get('adhesionFee')?.setValue(adhesionFee);
    this.form.get('dueDate')?.setValue(dueDate);
    this.form.get('deploymentValue')?.setValue(0);
    this.dueDateSelected = dueDate;

    const dayMonth = new Date().getDate();
    let dueInDays = 0;

    if (selectedPlan.isDaysCount && this.dueDateSelected > 0) {
      dueInDays = dayMonth > this.dueDateSelected
        ? 30 - dayMonth + this.dueDateSelected
        : this.dueDateSelected - dayMonth;
    }

    this.form.get('daysCountQuantity')?.setValue(dueInDays);
    this.showDaysCountQuantity = selectedPlan.isDaysCount === true;
    this.showAdeshionFee = Number(adhesionFee || 0) > 0;

    if (data.modules?.length) {
      this.selectedModules = data.modules.map((m: any) => ({
        id: m.id,
        name: m.name,
        adhesionValue: m?.adhesionValue ?? m?.adhesion_value ?? 0,
        accessValue: m?.accessValue ?? m?.access_value ?? 0,
        cost: m?.cost ?? 0
      }));
    }
    this.selectedMaxBranches = data?.maxBranches ?? null;
    this.selectedBranchCompositions = Array.isArray(data?.branchCompositions)
      ? data.branchCompositions
      : [];

    const incomingVariations = Array.isArray(data.variations) ? data.variations : [];
    const planVariations = Array.isArray(selectedPlan?.variations) ? selectedPlan.variations : [];
    this.selectedVariations =
      incomingVariations.length > 0
        ? incomingVariations
        : planVariations.filter((variation: any) =>
            String(variation?.status || 'ATIVO').toUpperCase() !== 'INATIVO'
          );

    // Fluxo: ao finalizar seleção no modal, lança direto na planilha.
    this.saveItem();
  }

  private applyWizardSelectionToEditingRow(data: any, rowIndex: number): void {
    if (!this.dataSource?.data?.[rowIndex]) return;

    const selectedPlan = data.plan;
    const selectedSystem = data.system;
    const summary = data.summary || {};

    const selectedItem = this.dataSource.data[rowIndex];
    const dueDate = summary.dueDate ?? selectedPlan?.dueDate ?? selectedSystem?.dueDate ?? selectedItem?.dueDate ?? 0;
    const daysCountQuantity =
      selectedPlan?.isDaysCount && Number(selectedItem?.daysCountQuantity || 0) > 0
        ? Number(selectedItem.daysCountQuantity)
        : 0;

    const monthlyValue = summary.monthlyValue ?? selectedPlan?.monthlyValue ?? selectedItem?.monthlyValue ?? 0;
    const adhesionFee = summary.adhesionFee ?? selectedPlan?.adhesionFee ?? selectedItem?.adhesionFee ?? 0;

    const updatedItem: any = {
      ...selectedItem,
      system: selectedSystem && typeof selectedSystem === 'object'
        ? selectedSystem
        : (selectedItem?.system ?? selectedSystem),
      systemModules: Array.isArray(data.modules) ? data.modules : (selectedItem?.systemModules || []),
      variations: Array.isArray(data.variations) && data.variations.length > 0
        ? data.variations
        : (selectedItem?.variations || []),
      branchCompositions: Array.isArray(data.branchCompositions)
        ? data.branchCompositions
        : (selectedItem?.branchCompositions || []),
      plan: selectedPlan,
      planId: selectedPlan?.id || selectedItem?.planId,
      planName: selectedPlan?.name || selectedSystem?.name || selectedItem?.planName || selectedItem?.name,
      terminalQuantity: selectedPlan?.terminalQuantity ?? selectedItem?.terminalQuantity,
      monthlyValue,
      adhesionFee,
      dueDate: Number(dueDate),
      daysCountQuantity,
      maxBranches: data.maxBranches ?? selectedItem?.maxBranches ?? null,
      maxUsers: selectedItem?.maxUsers,
      isDaysCount: selectedPlan?.isDaysCount === undefined ? selectedItem?.isDaysCount : !!selectedPlan?.isDaysCount,
      isUnitCommission: selectedItem?.isUnitCommission,
      // Motivo da alteração (Step 5 do wizard, obrigatório na edição — ver
      // specs/nexus/plan-wizard-cliente-redesign.md). Enforced no backend
      // (400) quando o customer_plan já existe (tem id).
      // O front NÃO cria a linha de auditoria aqui: customerPlanAudits tem
      // cascade:true na entity (CustomerPlan.customerPlanAudits) e o backend
      // (assertCustomerPlanUpdateReasons em customers.service.ts) já grava 1
      // registro a partir de updateReason. Se o front também empurrasse um
      // item aqui, cada edição gravaria 2 linhas de auditoria. Mantemos só o
      // histórico já existente (vindo do backend) para exibição.
      updateReason: data.updateReason || selectedItem?.updateReason,
      customerPlanAudits: selectedItem?.customerPlanAudits || [],
    };

    updatedItem.daysCountValue = updatedItem.isDaysCount && updatedItem.daysCountQuantity
      ? (Number(updatedItem.monthlyValue) / 30) * Number(updatedItem.daysCountQuantity)
      : 0;

    this.dataSource.data[rowIndex] = updatedItem;
    this.changeDataSourceChange();
  }

  private clearEditingPlanItemContext(): void {
    this.editingPlanItemIndex = null;
  }

  /**
   * Extrai o id do sistema de um item, independente do formato em que ele
   * estiver armazenado (objeto {id,name}, id numerico ou nome textual).
   */
  private getSystemId(item: any): any {
    if (!item) return null;
    const s = item.system !== undefined ? item.system : item;
    if (s == null) return null;
    if (typeof s === 'object') return s.id ?? null;
    if (typeof s === 'string' && isNaN(Number(s))) {
      return this.getSystemIdByName(s) ?? null;
    }
    return s;
  }

  /**
   * Indica se já existe um plano ativo apontando para o sistema informado.
   * Usado para impedir dois planos no mesmo sistema (conflito de acesso).
   */
  private hasActivePlanForSystem(systemId: any, exceptIndex: number = -1): boolean {
    if (systemId == null) return false;
    return this.dataSource.data.some((item: any, index: number) => {
      if (index === exceptIndex) return false;
      if (item?.active === false) return false;
      return String(this.getSystemId(item)) === String(systemId);
    });
  }

  private updatePendingPlanStatus(isPending: boolean): void {
    this.hasPendingPlan = isPending;
    this.hasPendingPlanChange.emit(isPending);
  }

  private checkPendingPlan(): boolean {
    const hasPlan = !!this.selectedPlanName;
    const hasTerminalQuantity = !!this.form.get('terminalQuantity')?.getRawValue();
    const hasMonthlyValue = !!this.form.get('monthlyValue')?.getRawValue();
    const hasDueDate = !!this.form.get('dueDate')?.getRawValue();
    const hasDeploymentValue = !!this.form.get('deploymentValue')?.getRawValue();

    const isPending = hasPlan && (hasTerminalQuantity || hasMonthlyValue || hasDueDate || hasDeploymentValue);
    return isPending;
  }
}

